import { render, staticRenderFns } from "./ProjectDestiniesModal.vue?vue&type=template&id=6b8ccd3c&scoped=true&"
import script from "./ProjectDestiniesModal.vue?vue&type=script&lang=js&"
export * from "./ProjectDestiniesModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDestiniesModal.vue?vue&type=style&index=0&id=6b8ccd3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8ccd3c",
  null
  
)

export default component.exports